import { ApiResponse } from '@magnetar/admin-api-interfaces'
import { useAuth } from './useAuth'
import { useGet } from './useFetch'
import { PeopleFlowDevice } from './usePeopleFlowDevice'

export function usePeopleFlowDeviceByExaminationRoom(examinationRoomId?: number) {
  const { token } = useAuth()

  const { data, error, mutate } = useGet<ApiResponse<PeopleFlowDevice>>(
    token && examinationRoomId
      ? `/api/examination-room/${examinationRoomId}/people-flow-device`
      : null,
    undefined,
    token ?? '',
  )

  return {
    device: data?.data,
    isLoading: !error && !data,
    isError: error,
    mutate,
  }
}

export function usePeopleFlowDeviceByBroadcastDevice(broadcastDeviceId?: number) {
  const { token } = useAuth()

  const { data, error, mutate } = useGet<ApiResponse<PeopleFlowDevice>>(
    token && broadcastDeviceId
      ? `/api/broadcast-device/${broadcastDeviceId}/people-flow-device`
      : null,
    undefined,
    token ?? '',
  )

  return {
    device: data?.data,
    isLoading: !error && !data,
    isError: error,
    mutate,
  }
}
